import { render, staticRenderFns } from "./ConsumeCouponConfigPane.vue?vue&type=template&id=dd12568e&scoped=true"
import script from "./ConsumeCouponConfigPane.vue?vue&type=script&lang=js"
export * from "./ConsumeCouponConfigPane.vue?vue&type=script&lang=js"
import style0 from "./ConsumeCouponConfigPane.vue?vue&type=style&index=0&id=dd12568e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd12568e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dd12568e')) {
      api.createRecord('dd12568e', component.options)
    } else {
      api.reload('dd12568e', component.options)
    }
    module.hot.accept("./ConsumeCouponConfigPane.vue?vue&type=template&id=dd12568e&scoped=true", function () {
      api.rerender('dd12568e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/activity/ConsumeCoupon/ConsumeCouponConfigPane.vue"
export default component.exports